var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnbIco18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.083 3V7.5C14.083 8.12227 14.5678 8.625 15.167 8.625H19.5V18.75C19.5 19.991 18.5281 21 17.333 21H6.66699C5.47194 21 4.5 19.991 4.5 18.75V5.25C4.5 4.00898 5.47194 3 6.66699 3H14.083ZM8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H11C11.5523 18 12 17.5523 12 17C12 16.4477 11.5523 16 11 16H8ZM8 13C7.44772 13 7 13.4477 7 14C7 14.5523 7.44772 15 8 15H14C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13H8ZM9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6ZM19.5 7.5H15.167V3L19.5 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco18);
export default __webpack_public_path__ + "static/media/Gnb_ico_18.4d0f6eebba5b54bae8b4587301e263eb.svg";
export { ForwardRef as ReactComponent };